import { render, staticRenderFns } from "./BasePageTurning.vue?vue&type=template&id=7b956adb&scoped=true&"
import script from "./BasePageTurning.vue?vue&type=script&lang=js&"
export * from "./BasePageTurning.vue?vue&type=script&lang=js&"
import style0 from "./BasePageTurning.vue?vue&type=style&index=0&id=7b956adb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b956adb",
  null
  
)

export default component.exports